module.exports = __webpack_public_path__ + "static/nail_polish-d9f9881e8a2b2830a762ecdc5cccfe7c.jpg";